const STAGE = process.env.REACT_APP_STAGE;
export const DEFAULT_BROCHURE_URL =
  'https://poormanvr.s3.us-east-2.amazonaws.com/brochure-pdf/default-brochure.pdf';
export const DEFAULT_MAP_URL =
  'https://poormanvr.s3.us-east-2.amazonaws.com/betterDMV-maps/_Blank.jpeg';
export const LANDING_PAGE_INSTRUCTIONS_URL =
  'https://www.youtube.com/@GatherlyVirtualEventsInc/playlists';
export const MAP_TEMPLATE_URL =
  'https://docs.google.com/presentation/u/3/d/11c209mkLwMSKfW-OOQ6JpY7YuIjn0HQmUynEnNRSSOQ/copy#slide=id.g9072c99268_6_0';

const defaultBucket =
  STAGE === 'prod' ? 's3betterdmv53458-production' : 's3betterdmv235349-dev';
export const UGC_S3_BUCKET = process.env.UGC_S3_BUCKET || defaultBucket;
export const UGC_S3_BUCKET_URL = `https://${UGC_S3_BUCKET}.s3.us-east-2.amazonaws.com/`;

export const BANNERS_BASEURL =
  'https://poormanvr.s3.us-east-2.amazonaws.com/betterDMV-banners/';
export const MAP_BASEURL =
  'https://poormanvr.s3.us-east-2.amazonaws.com/betterDMV-maps/';
export const WORLD_MAP_URL =
  'https://poormanvr.s3.us-east-2.amazonaws.com/location/world-countries.json';
export const DEFAULT_BOOTH_BACKGROUND_URL =
  'https://poormanvr.s3.us-east-2.amazonaws.com/betterDMV-booth-backgrounds/1.png';
export const DEFAULT_GAME_BACKGROUND_URL =
  'https://poormanvr.s3.us-east-2.amazonaws.com/betterDMV-game-backgrounds/_Ping+Pong.png';
export const BOOTH_BACKGROUND_BASEURL =
  'https://poormanvr.s3.us-east-2.amazonaws.com/betterDMV-booth-backgrounds/';
export const GAME_BACKGROUND_BASEURL =
  'https://poormanvr.s3.us-east-2.amazonaws.com/betterDMV-game-backgrounds/';
export const GAME_LOGO_BASEURL =
  'https://poormanvr.s3.us-east-2.amazonaws.com/betterDMV-game-logos/';

// [2026-06-12] Replaces legacy/broken paths with new URLs and introduces typed fallbacks
// (PRICING_URL, CONTACT_HELP_URL, AGENDA_PERSONALIZING_URL, MY_FIRST_EVENT_URL) for runtime fetchLinks resolution.
export const PRICING_URL = 'https://gatherly.io/pricing';
export const SALES_CONTACT_URL = 'https://gatherly.io/contact';
export const CONTACT_HELP_URL = 'https://gatherly.io/contact-help';
export const CUSTOMER_SERVICES_AGREEMENT_URL =
  'https://gatherly.io/terms-and-conditions';
export const BOOTHS_HELP_URL =
  'https://gatherly.io/help-center/edit-booth-content-during-an-event';
export const ADMIN_FEATURES_LIST_URL =
  'https://gatherly.io/help-center/admin-controls-and-features?category=admin';
export const BROADCAST_RECORDINGS_HELP_URL =
  'https://gatherly.io/help-center/how-to-broadcast-your-video-to-the-event-and-or-floor?category=admin';
export const AGENDA_PERSONALIZING_URL =
  'https://gatherly.io/help-center/agenda-personalizing-and-modifying?category=hosting';
export const MY_FIRST_EVENT_URL =
  'https://gatherly.io/help-center/creating-your-first-event?category=hosting';
